/* 🤖 this file was generated by svg-to-ts */
export const matIconChangeHistory: {
  name: 'change-history';
  data: string;
} = {
  name: 'change-history',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 7.77 18.39 18H5.61L12 7.77M12 4 2 20h20L12 4z"/></svg>`
};
